import GetShopNames from "../symbols/getShopNames";
export interface IShop {
  Id: string;
  Name: string;
};

export interface IShopByMerchant {
  ShopName: string;
  ShopId: string;
};

export interface IShopByMerchantResponse {
  MerchantId: string;
  MerchantName: string;
  Shops: IShopByMerchant[];
};

interface IState {
  data: IShopByMerchantResponse[];
  loading: boolean;
  error: boolean;
}
const initialState: IState = {
  data: [],
  loading: false,
  error: false,
};

export default function GetShopNamesReducer(
  state = initialState,
  action: any
) {
  switch (action.type) {
    case GetShopNames.GET_SHOP_NAMES:
      return { ...state, loading: true, error: false };
    case GetShopNames.GET_SHOP_NAMES_SUCCESS:
      return {
        ...state,
        data: action.payload.Result,
        loading: false,
        error: false,
      };
    case GetShopNames.GET_SHOP_NAMES_FAILURE:
      return {
        ...state,
        data: [],
        loading: false,
        error: true,
      };
    case GetShopNames.CLEAR_GET_SHOP_NAMES:
      return {
        ...state,
        data: [],
        loading: false,
        error: false,
      };

    default:
      return state;
  }
}
